import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ErrorAdvicerService {
  private errorMessage = new BehaviorSubject<string|null>(null);
  public errorMessage$ = this.errorMessage.asObservable();

  setErrorMessage(err:string)
  { this.errorMessage.next(err); }

  cleanErrorMessage()
  { this.errorMessage.next(null); }
}